let dd = require("ES/lib/dd");
let CoachingFields = require("./CoachingFields");
let CoachingScheduler = require("./CoachingScheduler");
let AuthedUserSession = require('../../../../../utils/AuthedUserSession');

module.exports = dd.createClass({
  render() {
    let {event, Displaylists} = this.props;
    let can_edit_numbers = AuthedUserSession.doIHaveAccess.full.any(event.sids);
    let can_edit_schedules = AuthedUserSession.doIHaveAccess.full.any(event.sids) || AuthedUserSession.doIHaveAccess.spkr.any(event.sids);

    return dd.div(null,
      dd.h2(null,
        "Coaching"
      ),
      CoachingFields({event, Displaylists, read_only: !can_edit_numbers}),
      dd.br(),
      dd.br(),
      CoachingScheduler({event, Displaylists, read_only: !can_edit_schedules})
    );
  }
});



// WEBPACK FOOTER //
// ./src/components/main_view/event_area/tabs/coaching/index.js